import { useState } from "react";
import { supabase } from "@/lib/supabase";
import { useNavigate } from "react-router-dom";

export default function ResetPasswordPage() {
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr(null);
    setMsg(null);

    if (password.length < 6) {
      setErr("Şifre en az 6 karakter olmalı.");
      return;
    }
    if (password !== password2) {
      setErr("Şifreler aynı değil.");
      return;
    }

    setLoading(true);
    try {
      // Recovery link ile gelince Supabase session otomatik oluşur.
      // Burada sadece yeni şifreyi set ediyoruz.
      const { error } = await supabase.auth.updateUser({ password });

      if (error) {
        setErr(error.message);
      } else {
        setMsg("Şifreniz güncellendi. Şimdi giriş yapabilirsiniz.");
        setTimeout(() => navigate("/giris"), 1200);
      }
    } catch (e: any) {
      setErr(e?.message || "Bir hata oluştu.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-black/30 p-6 backdrop-blur">
        <h1 className="text-2xl font-semibold mb-2">Şifre Sıfırla</h1>
        <p className="text-sm text-white/70 mb-6">Yeni şifrenizi belirleyin.</p>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="text-sm text-white/80">Yeni şifre</label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 w-full rounded-xl bg-white/10 border border-white/10 px-3 py-2 pr-10 outline-none"
                placeholder="******"
                required
              />

              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-white/60 hover:text-white"
              >
                {showPassword ? "🙈" : "👁️"}
              </button>
            </div>
          </div>

          <div>
            <label className="text-sm text-white/80">Yeni şifre (tekrar)</label>
            <div className="relative">
              <input
                type={showPassword2 ? "text" : "password"}
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
                className="mt-1 w-full rounded-xl bg-white/10 border border-white/10 px-3 py-2 pr-10 outline-none"
                placeholder="******"
                required
              />

              <button
                type="button"
                onClick={() => setShowPassword2(!showPassword2)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-white/60 hover:text-white"
              >
                {showPassword2 ? "🙈" : "👁️"}
              </button>
            </div>
          </div>

          {err && (
            <div className="rounded-xl border border-red-500/30 bg-red-500/10 p-3 text-sm text-red-200">
              {err}
            </div>
          )}

          {msg && (
            <div className="rounded-xl border border-emerald-500/30 bg-emerald-500/10 p-3 text-sm text-emerald-200">
              {msg}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-xl bg-rose-600 hover:bg-rose-700 disabled:opacity-60 px-4 py-2 font-medium"
          >
            {loading ? "Kaydediliyor..." : "Şifreyi Güncelle"}
          </button>

          <button
            type="button"
            onClick={() => navigate("/giris")}
            className="w-full rounded-xl border border-white/15 hover:bg-white/5 px-4 py-2 font-medium"
          >
            Giriş sayfasına dön
          </button>
        </form>
      </div>
    </div>
  );
}
